import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import React from 'react'

interface TabContentProps {
    type?: ListingLevel
}

export const TabContent: React.FC<TabContentProps> = ({ children }) => {
    return <>{children}</>
}
